import React from "react";
import { Link } from "react-router-dom";
import "../css/pages/notFound.scss";

const NotFound: React.FC = () => {
  return (
    <div className="not-found-container">
      <h1 className="not-found-title">۴۰۴</h1>
      <p className="not-found-message">
        اوه! صفحه‌ای که به دنبال آن هستید وجود ندارد.
      </p>
      <Link to="/" className="not-found-link">
        بازگشت به صفحه اصلی
      </Link>
    </div>
  );
};

export default NotFound;
